@if (!appSettings.isMobile()) {
  <div class="card border border-light-subtle bg-body-tertiary rounded h-100">
    @if (mode() !== formMode.VIEW && canCreate()) {
      <div class="card-header bg-transparent border-0 d-flex justify-content-end align-items-center pt-3 px-3">
        <button type="button" class="btn btn-primary btn-sm px-3" (click)="create.emit()">
          <i class="fas fa-plus me-1"></i> Registrar daño
        </button>
      </div>
    }
    <div class="card-body p-2 d-flex flex-column">
      <div class="table-responsive claim-detail-list__table">
        <table class="table mb-0 align-middle">
          <thead>
            <tr>
              <th class="ps-3 text-muted small text-uppercase fw-semibold">Descripción</th>
              <th class="text-start text-muted small text-uppercase fw-semibold">Estado</th>
              <th class="text-end text-muted small text-uppercase fw-semibold">Costo Estimado</th>
              <th class="text-center text-muted small text-uppercase fw-semibold"><i class="fas fa-cog"></i></th>
            </tr>
          </thead>
          <tbody>
            @if (details().length > 0) {
              @for (det of details(); track $index) {
                <tr>
                  <td class="ps-3 align-middle">
                    <div class="d-flex align-items-center gap-2 mb-1">
                      <span class="fw-bold text-dark fs-6">{{ det.geographicLocation }}</span>
                    </div>
                    <small class="text-muted d-block claim-detail-list__meta">
                      <i class="far fa-calendar me-1"></i>{{ det.dateOfLoss | date:'dd/MM/yyyy' }}
                      | <i class="far fa-user me-1"></i>
                      @if (isDriverParty(det)) {
                        Socio (Conductor)
                      } @else {
                        Conductor: {{ det.driverName }} (Clase {{ det.driverLicenseClass }})
                      }
                    </small>
                  </td>
                  <td class="text-start align-middle fw-semibold text-dark fs-6 pe-3">
                    <span class="badge border {{ statusClass(det) }}">{{ statusLabel(det) }}</span>
                  </td>
                  <td class="text-end align-middle fw-semibold text-dark fs-6 pe-3">
                    ${{ detailCost(det) | number:'1.0-0':'es-CL' }}
                  </td>
                  <td class="text-center align-middle">
                    <div class="d-flex align-items-center justify-content-center gap-2">
                      <button type="button" class="btn btn-outline-primary btn-xs" (click)="open.emit(det)" title="Ver y Subir Evidencias">
                        <i class="fas fa-eye me-1"></i>
                      </button>
                      @if (mode() !== formMode.VIEW && det.statusSlug !== 'REVIEWING') {
                        <button type="button" class="btn btn-outline-danger btn-xs" (click)="remove.emit($index)" title="Quitar Daño">
                          <i class="fas fa-trash"></i>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            } @else {
              <tr>
                <td colspan="4" class="text-center py-5 text-muted">
                  <i class="fas fa-car-crash fs-2 d-block mb-3 text-muted"></i>
                  @if (mode() === formMode.VIEW) {
                    No hay daños registrados en este siniestro.
                  } @else {
                    No se han agregado daños al siniestro aún. Pulse <strong>"Registrar daño"</strong> para comenzar.
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
} @else {
  <div class="d-flex justify-content-between align-items-center mb-2 px-1">
    <span class="small text-muted fw-bold text-uppercase claim-detail-list__section-label">
      Daños Registrados ({{ details().length }})
    </span>
  </div>

  @if (details().length > 0) {
    <div class="d-flex flex-column gap-2">
      @for (det of details(); track $index) {
        <app-list-card
          [isShortcut]="true"
          (click)="open.emit(det)">
          <div cardTitle class="fw-bold text-dark text-truncate">
            {{ det.geographicLocation || 'Ubicación no especificada' }}
          </div>

          @if (mode() !== formMode.VIEW && det.statusSlug !== 'REVIEWING') {
            <div cardActions>
              <button type="button" class="btn btn-outline-danger btn-xs"
                (click)="$event.stopPropagation(); remove.emit($index)"
                title="Quitar daño">
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          }

          <span cardBadge class="fw-bold text-dark font-monospace fs-6">
            ${{ detailCost(det) | number:'1.0-0':'es-CL' }}
          </span>

          <div class="text-muted small text-truncate claim-detail-list__card-meta">
            @if (affectedPartsLabel(det)) {
              <i class="fas fa-car me-1 text-danger"></i>{{ affectedPartsLabel(det) }}
            } @else if (det.damageDescription) {
              <i class="fas fa-car-crash me-1 text-danger"></i>{{ det.damageDescription }}
            }
          </div>
          <div class="text-muted small claim-detail-list__card-meta">
            <i class="far fa-calendar me-1"></i>{{ det.dateOfLoss | date:'dd/MM/yyyy' }}
            <span class="mx-1">·</span>
            <i class="far fa-user me-1"></i>
            @if (isDriverParty(det)) {
              Socio (Conductor)
            } @else {
              {{ det.driverName }}
            }
          </div>

          <span cardExtra class="text-uppercase fw-semibold text-muted claim-detail-list__section-label">
            ESTADO
          </span>
          <div cardAmount>
            <span class="badge border {{ statusClass(det) }}">{{ statusLabel(det) }}</span>
          </div>
        </app-list-card>
      }
    </div>
  } @else {
    <div class="card border border-light-subtle bg-body-tertiary rounded text-center py-4 px-3 text-muted">
      <i class="fas fa-car-crash fs-2 d-block mb-2 text-muted"></i>
      @if (mode() === formMode.VIEW) {
        No hay daños registrados en este siniestro.
      } @else {
        No se han agregado daños al siniestro aún. Use <strong>Registrar daño</strong> en la barra inferior para comenzar.
      }
    </div>
  }
}
